module.exports = __webpack_public_path__ + "img/wedding-carousel-3.303f634c.jpg";